import ReactDOM from 'react-dom'

import { lifecycle } from 'recompose'

export default lifecycle<AutoFocusProps, any>({
  UNSAFE_componentWillUpdate(nextProps) {
    const el = ReactDOM.findDOMNode(this as any) as HTMLElement
    if (el) {
      if (nextProps.shouldFocus) {
        el.focus()
      } else {
        el.blur()
      }
    }
  },
})

// For components that need to decide to autofocus or not
type AutoFocusProps = {
  shouldFocus: boolean
}

export { AutoFocusProps }
